import * as React from "react";
import { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";

import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import TableauDashboardContainer from "../sub-components/TableauDashboardContainer.tsx";

import "../../css/pageStyle.css";
import "../../css/homePageStyle.css";
import "../../sass/_dashboard.scss";
import HeaderBanner from "../sub-components/HeaderBanner.tsx";
import FavoritesRecentRecordsTabs from "../sub-components/FavoritesRecentRecordsTabs.tsx";
import Footer from "../sub-components/Footer.tsx";


const MyDashboard = () => {
  const [showSidebar, setShowSideBar] = useState(false);
  return (
    <div className="vh-100 landing-sub-main-page">
      <HeaderBanner />

      <div className="container-xxl landing-main">
        <div className="landing-section container-xxl">
          <Row className="landing-header">
            <Col md={11} className="landing-title" title={"Summary Dashboard"}>
              <h4 className="text-ellipsis">Dashboards</h4>
            </Col>

            <Col md={1}>
              <Button
                className="btn-light float-end"
                onClick={() => setShowSideBar(true)}
              >
                  <ArrowCircleLeftOutlinedIcon
                    color="action"
                    sx={{ color: "text.secondary" }}
                  />
              </Button>
              <FavoritesRecentRecordsTabs show={showSidebar}
                                                          onCanvasClose={() => setShowSideBar(false)} />
            </Col>
          </Row>
          <Row className="ps-0 pe-0">
            <Col md={12} className="ps-0 pe-0 pt-3 pb-3">
              <TableauDashboardContainer tableauUrl="HOME" dashboardPage={false} />
            </Col>
          </Row>
        </div>
      </div>
      <Footer cssClassName="footer-main-comp-dashboard"/>
    </div>
  );
};

export default MyDashboard;
